import * as React from "react";
import { cn } from "../../lib/utils";

const Input = React.forwardRef(({ className, type = "text", error = false, style, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-11 w-full rounded-md border bg-white/15 px-4 py-2 text-white placeholder:text-slate-300 shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50",
        error ? "border-red-400 focus-visible:ring-rose-400" : "border-white/40 focus-visible:ring-emerald-400",
        className
      )}
      style={style}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
